/**
 * All backend communication goes to the external API server — not this UI dev server.
 * Admin is only available on the API server (${REACT_APP_API_BASE_URL}/admin/).
 */
const PRODUCTION_API = 'https://api.bonitas.co.za';
const LOCAL_API = 'http://localhost:3000';

export function getApiBaseUrl() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '');
  }
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  return env === 'production' ? PRODUCTION_API : LOCAL_API;
}

export function getAdminUrl() {
  return `${getApiBaseUrl()}/admin/`;
}

export function apiPath(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}/api${normalized}`;
}
